import { AppLayout } from '../components/layout/AppLayout';
import { VideoAnalyzer } from '../components/dashboard/VideoAnalyzer';

export default function Dashboard() {
  return (
    <AppLayout>
      <div className="max-w-4xl mx-auto">
        <VideoAnalyzer />
      </div>
    </AppLayout>
  );
}

